import { FaPhoneAlt } from "react-icons/fa";

const FloatingPhoneButton = () => {
  const phone = "+919220198202";

  return (
    <a
      href={`tel:${phone}`}
      className="fixed bottom-20 right-6 bg-orange-500 hover:bg-orange-600 text-white p-3 rounded-full shadow-lg z-50"
      aria-label="Call Now"
    >
      <FaPhoneAlt size={20} />
    </a>
  );
};

export default FloatingPhoneButton;
